import styles from './AcknowledgeStatusFilter.module.scss';
import { useTranslation } from 'react-i18next';
import { ReactElement, useCallback, useMemo } from 'react';
import { SafetyAlertType } from '@casops/store/apis/commonModels';
import Dropdown from '@cas/components/inputs/dropdown/Dropdown';
import { useAppDispatch, useAppSelector } from '@casops/store/hooks';
import { saveFilters, setManDownStatus, setDuressStatus } from '@casops/store/slices/filtersSlice';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

const useAcknowledgedOptions = (): DropdownItemProps<boolean | null>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return [
      { key: '1', value: false, stringValue: '1', label: t('SafetyAlertStatus.Active') },
      { key: '2', value: true, stringValue: '2', label: t('SafetyAlertStatus.Acknowledged') },
      { key: '3', value: null, stringValue: '3', label: t('All') },
    ];
  }, [t]);
};

interface AcknowledgeStatusFilterProps {
  alertType: SafetyAlertType;
}

export const AcknowledgeStatusFilter = ({
  alertType,
}: AcknowledgeStatusFilterProps): ReactElement => {
  const dispatch = useAppDispatch();

  const acknowledgeOptions = useAcknowledgedOptions();

  const onChange = useCallback(
    (value: boolean | null) => {
      if (alertType === SafetyAlertType.Duress) {
        dispatch(setDuressStatus(value));
      } else {
        dispatch(setManDownStatus(value));
      }
      dispatch(saveFilters());
    },
    [dispatch, alertType],
  );

  const { duressStatus, manDownStatus } = useAppSelector(state => state.filters.saved);
  const statusFilter = alertType === SafetyAlertType.Duress ? duressStatus : manDownStatus;

  return (
    <div className={styles.acknowledgeFilter} key={alertType}>
      <Dropdown<boolean | null>
        uid="acknowledged"
        value={statusFilter}
        items={acknowledgeOptions}
        onChange={onChange}
      />
    </div>
  );
};
